var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer2Right(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 206,
    viewBox: "0 0 103 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_594_27230)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8998 171.824L91.7236 205.975L19.0255 205.142L33.2181 174.156L47.0721 170.607L41.3967 168.433L47.0721 141.537L47.3199 141.304L57.5555 131.417L31.9459 142.462L5.38629 142.02L0.0330811 136.189C0.0330811 136.189 24.9156 103.92 51.5413 81.1222V76.2661L44.7589 75.3915L31.9707 76.366C31.9707 76.366 34.8373 40.1321 78.927 8.42124L95.598 0C95.8707 0.44147 103.859 13.4107 101.703 36.1172L89.9639 54.7007L85.9903 63.5217L102.042 54.7173C102.042 54.7173 108.651 87.7776 86.4034 124.353L83.3716 135.856L79.7366 145.102L74.2347 149.817L73.8877 151.241L86.6182 143.111C86.6182 143.111 90.1044 154.648 88.5843 170.441L84.8998 171.824Z",
    fill: "url(#paint0_linear_594_27230)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.233 90.7347C97.6179 101.931 93.328 112.66 87.5103 122.554C87.1551 123.154 86.7999 123.753 86.4364 124.353L83.3716 135.856L79.7366 145.102L74.2347 149.817L73.8877 151.241L71.0129 163.144L46.9977 170.641L41.3223 168.467L46.9977 141.57L47.2455 141.337C68.9062 144.902 76.3578 142.07 76.3578 142.07L81.3889 124.72L57.4894 131.383L31.8798 142.428L5.38629 142.02L0.0330811 136.189C18.1415 138.563 30.4341 135.881 30.4341 135.881C49.9882 129.717 95.8046 89.1104 96.5233 88.4774C100.356 64.3215 96.5233 58.6323 96.5233 58.6323L85.5194 65.7458L75.2756 70.3854L51.5083 81.1556V76.2995L44.7259 75.4249L31.9376 76.3994L59.8025 67.5284L92.8471 30.7531C98.7538 17.4257 95.6724 0.558178 95.5732 0.00842285C95.8458 0.449893 103.834 13.4191 101.678 36.1257L89.9391 54.7091L85.9655 63.5301L102.042 54.7174C102.042 54.7174 105.082 69.7357 100.233 90.7347Z",
    fill: "url(#paint1_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7235 206L53.524 205.559L18.9841 205.142L33.1768 174.156L44.7424 173.973L73.7886 165.818L83.7019 153.273L86.6512 143.111C86.6512 143.111 90.1374 154.648 88.6173 170.441L84.8998 171.824L91.7235 206Z",
    fill: "url(#paint2_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9208 151.241L69.4846 159.554L51.5 166.009L41.3553 168.425L47.039 170.607L71.0459 163.136L73.9208 151.241Z",
    fill: "url(#paint3_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8999 171.824L63.297 176.98H81.4137L87.6509 185.576L84.8999 171.824Z",
    fill: "url(#paint4_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7235 206L53.524 205.559L49.8395 205.384L44.7258 173.973L73.7721 165.818L83.6854 153.273L86.6346 143.111C86.6346 143.111 90.1208 154.648 88.6008 170.441L84.8833 171.824L91.7235 206Z",
    fill: "url(#paint5_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.233 90.7346C97.6179 101.931 93.328 112.66 87.5104 122.554H86.106L79.8854 124.62L57.5142 131.45L84.5281 120.621L96.482 88.5439L100.233 90.7346Z",
    fill: "url(#paint6_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.711 36.1341L89.9721 54.7175L85.9985 63.5386L75.259 70.3939L51.4917 81.1641V76.3079L66.1139 72.0182L87.5929 50.4444L92.8305 30.7615C98.7372 17.4341 95.6558 0.566601 95.5567 0.0168457C95.8789 0.458316 103.851 13.4276 101.711 36.1341Z",
    fill: "url(#paint7_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9841 137.122L31.0619 137.231L38.3978 135.506L49.0299 128.118L51.5083 124.711L68.2371 114.158L89.1048 99.9972L93.9705 95.2827L99.9516 91.4593L100.241 68.8694L98.0433 65.6625C98.0433 65.6625 98.415 80.1477 96.4985 88.5107L62.0495 117.073L33.1355 135.19L28.757 136.214L18.9841 137.122Z",
    fill: "url(#paint8_linear_594_27230)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.593 190.707L41.3553 194.147H48.0138L68.2288 192.423L84.5611 193.497H89.2286L91.2526 203.618L72.6402 199.253L48.4599 196.854L40.2896 195.988L23.4286 195.446L25.593 190.707Z",
    fill: "#9387D1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6489 179.67L45.4612 178.454L57.6381 179.953L81.6698 183.169L86.7339 181.003L86.1969 178.304L80.3232 181.453L63.297 179.953L45.2712 177.263L31.6898 177.413L30.6489 179.67Z",
    fill: "#9387D1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8251 151.991H62.0496L68.2289 149.125L76.7957 146.493L79.7697 145.102L74.2678 149.817L73.9208 151.241L64.627 154.823L60.3973 158.246L50.4839 158.763L43.6768 157.438L44.8251 151.991Z",
    fill: "#9387D1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2678 149.817L71.9547 146.918L58.6956 142.695C58.6956 142.695 64.2966 143.686 76.4322 142.02L79.7367 145.102L74.2678 149.817Z",
    fill: "url(#paint9_linear_594_27230)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6438 136.781L35.8286 133.499L32.0285 140.396L28.3109 138.68L22.6438 136.781Z",
    fill: "#644AAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.358 68.9526L65.5275 61.1727L61.7274 69.9688L55.358 68.9526Z",
    fill: "#644AAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.224 173.973L45.2712 177.263L50.3187 172.398L39.224 173.973Z",
    fill: "#644AAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_594_27230",
    x1: 51.5,
    y1: 206,
    x2: 51.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401B66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_594_27230",
    x1: 0.0000364676,
    y1: 85.3121,
    x2: 103,
    y2: 85.3121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_594_27230",
    x1: 18.9841,
    y1: 174.556,
    x2: 91.7235,
    y2: 174.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_594_27230",
    x1: 41.3553,
    y1: 160.928,
    x2: 73.9208,
    y2: 160.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_594_27230",
    x1: 63.297,
    y1: 178.695,
    x2: 87.6509,
    y2: 178.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_594_27230",
    x1: 44.7258,
    y1: 174.556,
    x2: 91.7235,
    y2: 174.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_594_27230",
    x1: 57.5142,
    y1: 109.968,
    x2: 100.233,
    y2: 109.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_594_27230",
    x1: 51.5082,
    y1: 40.5905,
    x2: 102.075,
    y2: 40.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_594_27230",
    x1: 18.9841,
    y1: 101.447,
    x2: 100.233,
    y2: 101.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_594_27230",
    x1: 58.6956,
    y1: 145.927,
    x2: 79.7697,
    y2: 145.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#542E77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_594_27230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 206,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer2Right);
export default __webpack_public_path__ + "static/media/layer2right.67ba2d3e92a3ad3378cea957eccb428d.svg";
export { ForwardRef as ReactComponent };